// components
import '../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import { AddBidModal } from './addBidModal';

const useAddBidModal = (ticketDetail) => {
  const addBidModalProps = { ticketDetail };
  const addBidModal = async () => {
    const { show } = await Modal.new({
      content: <AddBidModal addBidModalProps={addBidModalProps} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openAddBidModal = async () => {
    return await addBidModal();
  };

  return {
    openAddBidModal,
  };
};

export default useAddBidModal;
